module.exports = __webpack_public_path__ + "static/media/connect-guide-img-02.d3eec239.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/connect-guide-img-02.png
// module id = 964
// module chunks = 0